import { GlobalState } from "src/reducers";

export function getIsMobile(state: GlobalState): boolean {
    return state.ui.observer.isDeviceMobile;
}
